import type { RatioPositionFetcher } from "@stepfinance/lending";
import { useQuery } from "@tanstack/react-query";

export const useRatioQuery = (fetcher?: RatioPositionFetcher) =>
  useQuery(
    ["ratio", fetcher?.pubKey.toBase58()],
    async () => {
      if (fetcher) {
        const positions = await fetcher.fetchPositions();
        return positions;
      }
      return null;
    },
    {
      retry: false,
      enabled: !!fetcher,
    },
  );
